import { render, staticRenderFns } from "./ChatInfoPanel.vue?vue&type=template&id=26b9b3c8&scoped=true"
import script from "./ChatInfoPanel.vue?vue&type=script&lang=js"
export * from "./ChatInfoPanel.vue?vue&type=script&lang=js"
import style0 from "./ChatInfoPanel.vue?vue&type=style&index=0&id=26b9b3c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b9b3c8",
  null
  
)

export default component.exports